<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-map-marker-alt" id="ico"></i>
		<h1 style="display: inline-block;">{{titulo}}</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<form [formGroup]="formPInteres" autocomplete="off">
			<div class="row">
				<div class="col-md-12">
					<i class="fas fa-signature"></i>&nbsp;
					<label for="nombre">Nombre</label>
					<input formControlName="nombre" class="form-control" id="nombre">
				</div>
				<div class="col-md-12 mt-3">
					<i class="fas fa-edit"></i>&nbsp;
					<label for="descripcion">Descripción</label>
					<input formControlName="descripcion" class="form-control" id="descripcion">
				</div>
				<div class="col-md-12 mt-3">
					<i class="fas fa-icons"></i>&nbsp;
					<label for="icono">Icono</label>
					<!--<select id="icono" formControlName="icono" class="form-control">
						<option *ngFor="let marcador of marcadores" [value]="marcador.url">
							<img src={{marcador.url}} class="img-thumbnail">&nbsp;
							{{marcador.nombre}}
						</option>
					</select>-->

					<mat-select class="form-control" matSelect formControlName="icono">
						<mat-option *ngFor="let item of marcadores" [value]="item.url"><img
								src={{item.url}}>&nbsp;{{item.nombre}}
						</mat-option>
					</mat-select>
				</div>
			</div>
			<mat-divider class="mt-3"></mat-divider>
			<div class="kt-portlet__foot">
				<div class="kt-form__actions kt-form__actions">
					<button id="boton-sion" mat-raised-button class="mt-3  btn btn-success" style="margin-right: 15px;"
						(click)="onSubmit()" [disabled]="formPInteres.invalid"><i
							class="fa fa-check"></i>&nbsp;Guardar</button>&nbsp;
					<button mat-raised-button [mat-dialog-close]><i class="fas fa-times"></i>&nbsp;Cancelar</button>
				</div>
			</div>
		</form>
	</div>
</div>
